import { Link } from "react-router-dom";
import linkedinIcon from "@/assets/linkedin-icon.png";
import logo from "@/assets/laanded-logo.png";
import { useContentBlock } from "@/hooks/useContentBlock";

interface FooterContactData {
  email: string;
  phone: string;
  phone_raw: string;
  address_line1: string;
  address_line2: string;
  address_line3: string;
  address_url: string;
  linkedin_url: string;
}

const defaultContact: FooterContactData = {
  email: "hello@laanded.com.au",
  phone: "+61 2 9909 5611",
  phone_raw: "+61299095611",
  address_line1: "101/377 New South Head Road",
  address_line2: "Double Bay NSW 2028",
  address_line3: "Australia",
  address_url: "https://maps.app.goo.gl/EVTGxUcy9gv9hdMj9?g_st=ic",
  linkedin_url: "https://linkedin.com/company/laanded"
};

const Footer = () => {
  const { data: rawContent } = useContentBlock("Footer Contact Details");

  let contact = defaultContact;
  if (rawContent) {
    try {
      contact = { ...defaultContact, ...JSON.parse(rawContent) };
    } catch {















      // fall back to defaults
    }}return <footer className="border-t border-border bg-background">
      <div className="section-padding py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img src={logo} alt="LAANDED Property Group" className="h-12 md:h-16 w-auto mb-4" />
            <p className="body-base text-sm max-w-xs">
              Privately led property development.
            </p>
          </div>

          <div>
            <p className="label-caps mb-4">Navigation</p>
            <div className="space-y-2">
              {[{ label: "Home", href: "/" }, { label: "About", href: "/about" }, { label: "Projects", href: "/developments" }, { label: "Asset Classes", href: "/asset-classes" }, { label: "How We Work", href: "/how-we-work" }, { label: "Insights", href: "/insights" }, { label: "Contact", href: "/contact" }, { label: "Disclaimer", href: "/disclaimer" }].map((link) => <Link key={link.href}
              to={link.href}
              className="block text-sm text-muted-foreground hover:text-foreground transition-colors">
                
                  {link.label}
                </Link>
            )}
            </div>
          </div>

          <div>
            <p className="label-caps mb-4 text-muted-foreground font-extrabold">Contact</p>
            <div className="space-y-2 text-sm text-muted-foreground">
              <p className="label-caps mb-1 font-bold text-primary" style={{ fontSize: '0.65rem' }}>Email</p>
              <a href={`mailto:${contact.email}`} className="block hover:text-foreground transition-colors">{contact.email}</a>
              <p className="label-caps mb-1 mt-3 font-bold text-primary" style={{ fontSize: '0.65rem' }}>Phone</p>
              <a href={`tel:${contact.phone_raw}`} className="block hover:text-foreground transition-colors">{contact.phone}</a>
              <p className="label-caps mb-1 mt-3 font-bold text-primary" style={{ fontSize: '0.65rem' }}>Address</p>
              <a
              href={contact.address_url}
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:text-foreground transition-colors">
                
                {contact.address_line1}<br />{contact.address_line2}<br />{contact.address_line3}
              </a>
            </div>
            <a
            href={contact.linkedin_url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-4 text-sm text-muted-foreground hover:text-foreground transition-colors"
            aria-label="LAANDED on LinkedIn">
              
              <img src={linkedinIcon} alt="LinkedIn" className="h-[18px] w-[18px]" />
              <span>LinkedIn</span>
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} LAANDED Property Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;

};

export default Footer;